/**
 * Styled Components - Created by miguelcanobbio on 16/07/18.
 */
import styled from 'styled-components'
import Checkbox from 'antd/lib/checkbox'
import {
  GRAY_BORDER,
  GRAY_DARK,
  WHITE
} from '../../../theme/colors'

interface ContainerProps {
  withoutPadding?: boolean
  marginTop?: string
}

export const Container = styled.div`
  margin-top: ${({ marginTop }: ContainerProps) => marginTop ? marginTop : '0'};
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: ${({ withoutPadding }: ContainerProps) =>
    withoutPadding ? '0' : '32px'};
  @media (min-width: 320px) and (max-width: 768px) {
    padding-right: 0;
    align-items: center;
  }
  @media (max-width: 698px) {
    margin-top: 0px;
  }
`

export const ListMobile = styled.div`
  display: flex;
  flex-flow: column;
  margin-bottom: 20px;
`

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 24px;
`

export const Row = styled.tr``

interface HeaderProps {
  textAlign?: string
}

export const Header = styled.th`
  border-bottom: 1px solid ${GRAY_BORDER};
  text-align: left;
  padding: 8px 0;
  color: ${GRAY_DARK};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 23px;
  text-align: ${({ textAlign }: HeaderProps) =>
    textAlign ? textAlign : 'start'};

  @media (min-width: 320px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 12px;
    line-height: 15px;
  }
`

export const ArchivedFilter = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 15px 0px;
`

export const CheckboxLabel = styled.div`
  white-space: nowrap;
  margin-right: 10px;
`

export const CheckboxStyled = styled(Checkbox)`
  width: 100%;
  text-align: center;
`

export const Tag = styled.div`
  color: #4ea597;
  padding: 6px 0px;
  min-width: 88px;
  text-align: center;
  transition: background-color 0.3s ease;
  margin: 8px 0px 0 0;
  &.selected {
    background: #7ea39d;
    color: ${WHITE};
  }
  &:hover {
    cursor: pointer;
    color: ${WHITE};
    background: #77a39c;
  }
`

export const TagsContainer = styled.div`
  margin-top: -26px;
  width: 18%;
  border-bottom: 1px solid #4ea597;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyLocker/ListView/styledComponents.tsx